module.exports = __webpack_public_path__ + "static/media/w_y_25.eeafa8c5.png";